import { Preventif } from '@/models/Preventif';
import { MutationTree } from 'vuex';
import PreventifService, { PERIOD, Periodicite, Vision } from '../services/PreventifService';
import { PREVENTIF } from './mutation-types';
import { initialState as resetState, PreventifState } from './state';

export const mutations: MutationTree<PreventifState> = {
    [PREVENTIF.SET_ITEMS](state, items: Preventif[]) {
        state.preventif = items;
    },
    [PREVENTIF.ADD_ITEMS](state: PreventifState, items: Preventif[]): void {
        state.preventif = [...state.preventif, ...items];
    },
    [PREVENTIF.ADD_BEFORE](state, items: Preventif[]) {
        const emptyPlanning = state.header.slice(0, state.nbPeriodesStep);
        const combinedData = state.preventif.map((x: Preventif) => ({
            id: x.id,
            libelle: x.libelle,
            interventionId: x.interventionId,
            periodesPlanning: PreventifService.concatenerPeriodesDesNoeuds(x, items?.filter(n => n.id === x.id)[0], emptyPlanning, PERIOD.BEFORE),
            noeudsEnfants: PreventifService.combinePreventiveData(x, items, emptyPlanning, PERIOD.BEFORE, state.header, state.periodicite),
        }));
        PreventifService.addNewNoeudsEnfants(combinedData, items, PERIOD.BEFORE, state.header, state.periodicite);
        state.preventif = combinedData;
    },
    [PREVENTIF.ADD_AFTER](state, items: Preventif[]) {
        const emptyPlanning = state.header.slice(-state.nbPeriodesStep);
        const combinedData = state.preventif.map((x: Preventif) => ({
            id: x.id,
            libelle: x.libelle,
            interventionId: x.interventionId,
            periodesPlanning: PreventifService.concatenerPeriodesDesNoeuds(x, items?.filter(n => n.id === x.id)[0], emptyPlanning, PERIOD.AFTER),
            noeudsEnfants: PreventifService.combinePreventiveData(x, items, emptyPlanning, PERIOD.AFTER, state.header, state.periodicite),
        }));
        PreventifService.addNewNoeudsEnfants(combinedData, items, PERIOD.AFTER, state.header, state.periodicite);
        state.preventif = combinedData;
    },
    [PREVENTIF.SET_DISPLAY](state) {
        state.displayHeader = state.header.slice(state.page, state.page + state.nbPeriodesAffichees);
        if (state.preventif !== undefined) {
            state.displayPreventif = PreventifService.transformDisplayData(state.preventif, state.page, state.nbPeriodesAffichees);
        }
    },
    [PREVENTIF.FILTER_BY_SITE](state, filter: string) {
        state.siteFilter = filter;
    },
    [PREVENTIF.SET_HEADER](state, items: { dateDebut: string; dateFin: string }[]) {
        state.header = items;
    },
    [PREVENTIF.SET_PAGE](state, page: number) {
        state.page = page;
    },
    [PREVENTIF.SWITCH_PERIODICITE](state) {
        if(state.periodicite === Periodicite.MENSUELLE){
            state.periodicite = Periodicite.HEBDOMADAIRE;
        } else {
            state.periodicite = Periodicite.MENSUELLE;
        }
    },
    [PREVENTIF.SWITCH_PREVISIONNEL_REEL](state) {
        if(state.previsionnel === Vision.PREVISIONNELLE){
            state.previsionnel = Vision.REELLE;
        } else {
            state.previsionnel = Vision.PREVISIONNELLE;
        }
    },
    [PREVENTIF.SET_LOADING](state, loading: boolean) {
        state.isLoading = loading;
    },
    [PREVENTIF.SET_ERROR](state, error?: Error) {
        state.error = error;
    },
    [PREVENTIF.RESET](state) {
        Object.assign(state, resetState);
    },
    [PREVENTIF.SET_LOADING_XLS_PREVENTIF](state, loading: boolean) {
        state.xlsInterventionsPreventivesLoading = loading;
    },
    [PREVENTIF.IS_ALL_DATA](state: PreventifState, isAllData: boolean): void {
        state.isAllData = isAllData;
    },
    [PREVENTIF.SET_LAST_SITE_ID](state: PreventifState, lastSiteId: number): void {
        state.lastSiteId = lastSiteId;
    },
    [PREVENTIF.SET_IS_UNIQUE_SITE](state: PreventifState, isUniqueSite: boolean): void {
        state.isUniqueSite = isUniqueSite;
    }
};
